import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Base<ComponentProps>}
 */
export default class Share extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Share',
    refs: ['tooltip'],
  };

  onClick() {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        this.$refs.tooltip.classList.remove('tw-opacity-0', 'tw-translate-y-1');
        setTimeout(() => {
          this.$refs.tooltip.classList.add('tw-opacity-0', 'tw-translate-y-1');
        }, 1000);
      })
      .catch((err) => {
        console.error('Erreur lors de la copie :', err);
      });
  }
}
